module.exports = __webpack_public_path__ + "assets/img/section1.1f0d2360.png";